import React from "react";
import PropTypes from "prop-types";

class NotFound extends React.Component {
  
  static propTypes = {
    history: PropTypes.object.isRequired
  };

  goToHomepage = event => {
    // 1. Stop the form from submitting
    event.preventDefault();
    // 2. Change the page to "/" homepage
    this.props.history.push(`/`);
  };

  render() {
    return (
      <section className="content">
        <div className="wrapper not-found">
          <h1>404_</h1>
          <p>You're beyond the borders.</p>
          <button onClick={this.goToHomepage}>Reroute</button>
        </div>
      </section>
    )
  }
}

export default NotFound;